import { Badge, type BadgeProps, cn } from "@shared/ui";

export const StatusBadge = ({ children, className, ...props }: BadgeProps) => {
    return (
        <Badge {...props} size="sm" className={cn("px-2 py-[0.5px] rounded-full border-[1.5px]", className)}>
            {children}
        </Badge>
    )
}